/* eslint-disable no-unused-vars */
import {
  get as getAxios,
  post as postAxios,
  put as putAxios,
  deleteCall as deleteAxios,
} from "../apiHandler";

const endPoint = process.env.REACT_APP_API_BASE_URL;
const PAGE_SIZE = 5;

// const accessTokenFromLocal = "0fc0515a-d081-4b4a-83ab-7c104c2e1357";

const get = (url, { data, accessToken }) =>
  getAxios(url, { data, accessToken, endPoint });
const post = (url, { accessToken, data, params }) =>
  postAxios(url, { accessToken, data, endPoint, params });
const put = (url, { accessToken, data, params }) =>
  putAxios(url, { accessToken, data, endPoint, params });
const deleteCall = (url, { accessToken, data, params }) =>
  deleteAxios(url, { accessToken, data, endPoint, params });

export default class Friends {
  static forwardFriend({ data, friendId, transferRequestId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/friends/${friendId}/transferRequests/${transferRequestId}/forward`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Friends.forwardFriend.cancel = request.cancel;
    return request;
  }

  static transferFriend({ data, friendId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/friends/${friendId}/transfer`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Friends.transferFriend.cancel = request.cancel;
    return request;
  }

  static acceptFriend({ data, friendId, transferRequestId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/friends/${friendId}/transferRequests/${transferRequestId}/accept?blockId=${data.blockId}`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Friends.acceptFriend.cancel = request.cancel;
    return request;
  }

  static rejectFriend({ data, friendId, transferRequestId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/friends/${friendId}/transferRequests/${transferRequestId}/reject `,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Friends.rejectFriend.cancel = request.cancel;
    return request;
  }

  static searchFriend(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/friends/search`, {
      accessToken: accessTokenFromLocal,
      data: {
        ...data,
        pageNumber: data.pageNumber || 0,
        pageSize: data.pageSize || 100,
      },
    });

    Friends.searchFriend.cancel = request.cancel;
    return request;
  }

  static searchBulkFriend(data, paginationParams) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/friends/search`, {
      accessToken: accessTokenFromLocal,
      data: {
        ...data,
        pageNumber: paginationParams?.pageNumber || 0,
        pageSize: paginationParams?.pageSize || PAGE_SIZE,
      },
    });

    Friends.searchBulkFriend.cancel = request.cancel;
    return request;
  }

  static searchFriendInTransferRequests(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/friends/search/transferRequests`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Friends.searchFriendInTransferRequests.cancel = request.cancel;
    return request;
  }

  static getPendingTransfer({ pageNumber, pageSize, type }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(
      `/api/friends/pendingTransfers?page=${pageNumber}&size=${pageSize}&type=${type}`,
      {
        accessToken: accessTokenFromLocal,
      }
    );

    Friends.getPendingTransfer.cancel = request.cancel;
    return request;
  }

  static postNewFriend({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/friends`, {
      data,
      accessToken: accessTokenFromLocal,
    });

    Friends.postNewFriend.cancel = request.cancel;
    return request;
  }

  static changeToNewFriend({ data, introductionId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(
      `/api/introductions/${introductionId}/convertToNewFriend`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Friends.changeToNewFriend.cancel = request.cancel;
    return request;
  }

  static addRemarkForFriendTransfer({ data, friendId, transferRequestId }) {
    const accessToken = localStorage.getItem("authToken");
    const request = post(
      `/api/friends/${friendId}/transferRequests/${transferRequestId}/remarks`,
      {
        accessToken,
        data,
      }
    );

    Friends.addRemarkForFriendTransfer.cancel = request.cancel;

    return request;
  }

  static getFriendRemarks({ transferId }) {
    const accessToken = localStorage.getItem("authToken");
    const request = get(`/api/friends/${transferId}/remarks`, {
      accessToken,
    });

    Friends.getFriendRemarks.cancel = request.cancel;
    return request;
  }

  static cancelFriend({ id, friendId }) {
    const accessToken = localStorage.getItem("authToken");
    const request = put(`/api/friends/${friendId}/transfers/${id}/cancel`, {
      accessToken,
    });

    Friends.cancelFriend.cancel = request.cancel;
    return request;
  }

  static friendView(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/friends/${data}`, {
      accessToken: accessTokenFromLocal,
    });

    Friends.friendView.cancel = request.cancel;
    return request;
  }

  static getAttendanceByFriendId(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/friends/${data}/attendance`, {
      accessToken: accessTokenFromLocal,
    });

    Friends.getAttendanceByFriendId.cancel = request.cancel;
    return request;
  }

  static friendUpdate(data, friendId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(`/api/friends/${friendId}`, {
      accessToken: accessTokenFromLocal,
      data,
    });
    Friends.friendUpdate.cancel = request.cancel;
    return request;
  }

  static friendDeactivate({ data, friendId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(`/api/friends/${friendId}/deactivate`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Friends.friendDeactivate.cancel = request.cancel;
    return request;
  }

  static getFriendToMember(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/reporting/friends/conversion-count`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Friends.getFriendToMember.cancel = request.cancel;
    return request;
  }

  static deleteNewFriend(friendId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = deleteCall(`/api/friends/${friendId}`, {
      accessToken: accessTokenFromLocal,
    });

    Friends.deleteNewFriend.cancel = request.cancel;
    return request;
  }

  static friendSearch({
    name = "",
    pageNumber = 0,
    pageSize,
    areaId,
    zoneId,
    regionId,
    chapterId,
    districtId,
  }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(
      `/api/friends/search?fullName=${name}&pageNumber=${pageNumber}&pageSize=${pageSize}&areaId=${areaId}&zoneId=${zoneId}&regionId=${regionId}&chapterId=${chapterId}&districtId=${districtId}`,
      {
        accessToken: accessTokenFromLocal,
      }
    );
    Friends.friendSearch.cancel = request.cancel;
    return request;
  }

  static getFriendPendingTransfer(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/friends/pendingTransfers`, {
      accessToken: accessTokenFromLocal,
      data: {
        ...data,
        page: data.page,
        size: data.size,
      },
    });

    Friends.getFriendPendingTransfer.cancel = request.cancel;
    return request;
  }

  static friendTransferEligibility({ data, friendId }) {
    const accessToken = localStorage.getItem("authToken");
    const request = post(`/api/friends/${friendId}/transferRequests/eligible`, {
      accessToken,
      data,
    });

    Friends.friendTransferEligibility.cancel = request.cancel;

    return request;
  }
}
